import React from "react";
import "./../../UaeAttestation/UaeReq/UaeReq.css";

const ItalyReqMain = () => {
  return (
    <div className="uaeReqMainContainer">
      <div className="uaeReqMainContent">
        <h3>Requirement of apostille for Italy:</h3>
        <p>
          Legalization for Italy has its own necessity in the visa procedure &
          growth of the business in Italy. Apostille is required as it is among
          the countries that are a part of the Hague Convention which is also
          known as the Apostille Convention.
        </p>
        <p>
          There are policies of Italy that demand documents with MEA sticker to
          permit a visitor to stay or perform business in their nation. It is a
          part of security that shows the trustworthiness of the documents.
          Therefore, certification of documents becomes a necessity for these
          reasons.
        </p>
      </div>
      <div className="uaeReqMainContent">
        <h3>Total time to get Document Apostille:</h3>
        <p>
          The overall time needed to get Document Apostille depends on various
          reasons such as which state the certificate was issued from, or the
          sorts of documents, or the authority you require it from. Generally,
          it will take around 2-3 working days to accomplish the whole process
          of Italy Apostille service in Bangalore for certificates.
        </p>
      </div>
    </div>
  );
};

export default ItalyReqMain;
